
import { gsap } from 'gsap'
import { Observer } from 'gsap/Observer'
// import Cursor from './cursor'

export default function scrollingInit () {

  gsap.registerPlugin(Observer)

  const $ = jQuery
  // const isMobile = $('body').hasClass('mobile')
  const sections = document.querySelectorAll('section')
  const numberOfSections = sections.length
  const scroller = document.querySelector('.scroller')
  const scrollerNavigation = document.querySelector('#scroller-navigation')
  const footer = document.querySelector('footer')
  const scrollerAnimationDuration = 1
  let footerHeight = document.querySelector('footer').offsetHeight
  let sectionHeight = sections[0].clientHeight
  let scrollToFooter = (numberOfSections - 1) * sectionHeight + footerHeight
  let isBrandingShowing = true
  //global
  intramotev.currentIndex = 0
  intramotev.animating

  /* ==========================================================================
    Timelines init
    ========================================================================== */
  let tl = gsap.timeline({ defaults: { ease: 'power1.inOut' }, onComplete: () => intramotev.animating = false })

  let brandingTl = gsap.timeline({ defaults: { ease: 'power1.inOut' }, paused: true })
  brandingTl.to('h1, #header-logo', { y: -sectionHeight, duration: 1.2, onComplete: () => $('h1, #header-logo').hide() })
            .to('#tagline p', { autoAlpha: 0, duration: 0.3, stagger: 0.2, onComplete: ()=>{ $('#branding').hide() } }, '<0.1')

  /* ==========================================================================
    Preset
    ========================================================================== */
  // initate the cursor
  // new Cursor()

  // add the dotted scrolling navigation
  for (var i=0; i < numberOfSections; i++){
    $(scrollerNavigation).append('<div class="dot"></div>')
  }
  $(scrollerNavigation).find('.dot:nth-child(1)').addClass('current')

  $(scrollerNavigation).on('click', '.dot', (e) => {
    !$(e.currentTarget).hasClass('current') && intramotev.gotoSection($(e.currentTarget).index(), true)
  })

  $('#back-to-top').on('click', () => { intramotev.gotoSection(0, false) })

  /* ==========================================================================
    Intro
    ========================================================================== */
  let introTl = gsap.timeline({
    defaults: { duration: .7, ease: 'power1.inOut' },
  })
  introTl.delay(1.5)
    .from('h1', { opacity: 0 })
    .from('#tagline p', { autoAlpha: 0, stagger: 0.2}, '<0.2')
    .to('#scroller-navigation .dot', { alpha: 1, duration: 0.1, stagger: 0.05, ease: 'back.inOut' })

  /* ==========================================================================
    Scrolling
    ========================================================================== */
  window.intramotev.gotoSection = (index, isScrollingDown) => {
    if (index >= 0 && index < sections.length) {
      intramotev.animating = true

      $('section').removeClass('current')
      $(sections[index]).addClass('current')

      if(index === 0) {
        $('h1, #header-logo, #branding').show()
        brandingTl.reverse()
        isBrandingShowing = true
        gsap.to(scroller, { y: -sectionHeight * index, ease: 'power1.inOut', duration: scrollerAnimationDuration, onComplete: () => {
          intramotev.animating = false
          $(sections).find('p.clipped').removeClass('animated') 
        }})
      } else {
        if (isBrandingShowing) {
          brandingTl.play()
          isBrandingShowing = false
        }
        scrollerAnimation(tl, index, isScrollingDown)
      }

      $(scrollerNavigation).find('div').removeClass('current')
      $(scrollerNavigation).find('div:nth-child('+(index+1)+')').addClass('current')

      intramotev.currentIndex = index

    } else if( index === sections.length ) { // scroll to footer
      intramotev.animating = true
      if (isBrandingShowing) {
        brandingTl.play()
        isBrandingShowing = false
      }
      gsap.to(scroller, { y: -(scrollToFooter), duration: scrollerAnimationDuration, onComplete: () => intramotev.animating = false })
      gsap.to(scrollerNavigation, { opacity: 0, duration: .2 })
      intramotev.currentIndex = index
    }
  }

  function scrollerAnimation(scrollingTl, index, isScrollingDown) {
    if (index === 7 && isScrollingDown) { // carousel
      scrollingTl
        .to(scroller, { y: -sectionHeight * index, duration: scrollerAnimationDuration, onComplete: () => $(sections).find('p.clipped').removeClass('animated') })
        .from('.slick-slide', { x: '200%', opacity: 0.3, duration: 0.5, stagger: 0.1 }, '>-0.2')
        .from('.slick-arrow', { opacity: 0, duration: 0.3 }, '>-0.3')
        .from('.carousel-navigation', { opacity: 0, duration: 0.3 }, '>-0.1')
        .to(scrollerNavigation, { opacity: 1, duration: .3 }, '>-1')
    } else {
      scrollingTl
        .to(scroller, { y: -sectionHeight * index, duration: scrollerAnimationDuration, onComplete: () => $(sections).find('p.clipped').removeClass('animated') })
        .from($(sections[index]).find('p')[0], { '--clip': '100%', duration: .4 }, '>-0.5')
        .from($(sections[index]).find('p.clipped'), { '--clip': '100%', duration: .2, onComplete: () => $(sections[index]).find('p.clipped').addClass('animated') })
        .fromTo($(sections[index]).find('.animate-from-transparent'), {opacity: 0}, { opacity: 1, stagger:0.2, duration: .3, ease: 'linear' }, '<0.2')
        .to(scrollerNavigation, { opacity: 1, duration: .3 }, '>-1')
    }
  }

  Observer.create({
    target: window,
    type: 'wheel,touch,pointer',
    wheelSpeed: -1,
    onDown: () => !intramotev.animating && intramotev.gotoSection(intramotev.currentIndex - 1, false),
    onUp: () => !intramotev.animating && intramotev.gotoSection(intramotev.currentIndex + 1, true),
    tolerance: 30,
    preventDefault: true
  })

  /* ==========================================================================
    Other
    ========================================================================== */
  // on resize fires only once 100ms after dragging ended
  $(window).on('resize', () => {
    clearTimeout(window.resizedFinished)
    window.resizedFinished = setTimeout(() => {
      sectionHeight = sections[0].clientHeight
      footerHeight = footer.offsetHeight
      scrollToFooter = (numberOfSections - 1) * sectionHeight + footerHeight
      gsap.set(scroller, { y: (-sectionHeight * intramotev.currentIndex) })
    }, 100)
  })

}

